import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQ() {
  const { t } = useTranslation("schuifpui-reparatie");
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const left = items.slice(0, 5);
  const right = items.slice(5);

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("faq.h2")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div className="flex flex-col gap-3">
            {left.map((item, i) => (
              <div key={i} className="border border-brand-border rounded-xl overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-geist font-semibold text-sm md:text-base text-brand-text">
                    {item.q}
                  </span>
                  <i className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-brand-text/60 flex-shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`}></i>
                </button>
                {openIndex === i && (
                  <div className="px-5 pb-4">
                    <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            {right.map((item, i) => (
              <div key={i + 5} className="border border-brand-border rounded-xl overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === i + 5 ? null : i + 5)}
                  className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-geist font-semibold text-sm md:text-base text-brand-text">
                    {item.q}
                  </span>
                  <i className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-brand-text/60 flex-shrink-0 transition-transform ${openIndex === i + 5 ? "rotate-180" : ""}`}></i>
                </button>
                {openIndex === i + 5 && (
                  <div className="px-5 pb-4">
                    <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQPage schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.a,
            },
          })),
        })}
      </script>
    </section>
  );
}